export const CHANGELOG_SUBJECT_TYPE = 'App\\Models\\Order\\Order'

export const PACKING_STATUSES = [
  {
    name: 'Передано на отгрузку',
    value: 'transferred',
    icon: 'arrow-right',
    className: 'status status--orange',
    svgClass: 'svg-icon--arrow-right'
  },
  {
    name: 'Упаковано',
    value: 'packed',
    icon: 'button/packaging',
    className: 'status status--green',
    svgClass: 'svg-icon--packaging'
  }
]

export const TYPE_INDICATORS = [
  {
    title: 'Отправили пробные, ждём ОС',
    name: 'waiting_feedback',
    icon: 'waiting_feedback',
    className: 'status status--violet',
    svgClass: 'svg-icon--waiting_feedback'
  },
  {
    title: 'Нет металла',
    name: 'no_material',
    icon: 'no_material',
    className: 'status status--dark-orange',
    svgClass: 'svg-icon--no_material',
    showPosition: true
  },
  {
    title: 'Внутреннее согласование параметров',
    name: 'internal_parameter_coordination',
    icon: 'internal_parameter_coordination',
    className: 'status status--green',
    svgClass: 'svg-icon--internal_parameter_coordination'
  },
  {
    title: 'Внешнее согласование параметров',
    name: 'external_parameter_coordination',
    icon: 'external_parameter_coordination',
    className: 'status status--light-orange',
    svgClass: 'svg-icon--external_parameter_coordination',
    showPosition: true
  },
  {
    title: 'Внутреннее согласование нагрузок',
    name: 'internal_load_coordination',
    icon: 'internal_load_coordination',
    className: 'status status--green',
    svgClass: 'svg-icon--internal_load_coordination'
  },
  {
    title: 'Внешнее согласование нагрузок',
    name: 'external_load_coordination',
    icon: 'external_load_coordination',
    className: 'status status--light-orange',
    svgClass: 'svg-icon--external_load_coordination'
  }
]
